"use strict";
// 本来であれば定数はsrc/constants.ts ファイルに置きたかったが、
// WandhAvailableBooks の巨大リテラルにより constants.ts の型推論が重く、インポート時のコンパイル時間に影響するためここに配置している
// TODO: 以下PRの問題が解消された後、定数をsrc/constants.ts に移動する
// https://github.com/legalscape/wklr-mono/pull/6462#issuecomment-4051758528
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSONAL_SUBDOMAIN = exports.SH_SUBDOMAIN = exports.SUBDOMAINS = exports.DOMAINS = exports.DOMAIN_SUFFIXES = void 0;
exports.buildAccountPlatformUrl = buildAccountPlatformUrl;
exports.selectCookieDomain = selectCookieDomain;
exports.DOMAIN_SUFFIXES = {
    production: '.legalscape.jp',
    stage: '.stage.legalscape.dev',
    development: '.dev.legalscape.dev',
    developmentTagged: '.dev-tagged.legalscape.dev',
    test: '.test.legalscape.dev',
};
exports.DOMAINS = {
    kommentarTrial: 'kommentar-trial.legalscape.jp',
    shojihomuKommentar: 'shojihomu-kommentar.legalscape.jp',
    shojihomuKommentarLibrary: 'shojihomu-kommentar-library.legalscape.jp',
    personal: 'personal.legalscape.jp',
    accountPlatform: 'account.legalscape.jp',
};
const splitDomain = (domain) => domain.split('.', 1)[0];
exports.SUBDOMAINS = {
    kommentarTrial: splitDomain(exports.DOMAINS.kommentarTrial),
    shojihomuKommentar: splitDomain(exports.DOMAINS.shojihomuKommentar),
    shojihomuKommentarLibrary: splitDomain(exports.DOMAINS.shojihomuKommentarLibrary),
    personal: splitDomain(exports.DOMAINS.personal),
    accountPlatform: splitDomain(exports.DOMAINS.accountPlatform),
};
exports.SH_SUBDOMAIN = exports.SUBDOMAINS.shojihomuKommentar;
exports.PERSONAL_SUBDOMAIN = exports.SUBDOMAINS.personal;
/**
 * 現在のホスト名からアカウントプラットフォームのURLを構築する
 *
 * @example buildAccountPlatformUrl('org.legalscape.jp', '/auth/login') → 'https://account.legalscape.jp/auth/login'
 * @example buildAccountPlatformUrl('shojihomu-kommentar.legalscape.jp', '/auth/login') → '/auth/login'
 * @example buildAccountPlatformUrl('localhost:3000', '/auth/login') → '/auth/login'
 * @example buildAccountPlatformUrl('org.legalscape.jp', '/auth/login', { allowOrgSubdomainLogin: true }) → 'https://org.legalscape.jp/auth/login'
 */
function buildAccountPlatformUrl(host, path, options) {
    const suffix = Object.values(exports.DOMAIN_SUFFIXES).find((suffix) => host.endsWith(suffix));
    if (!suffix) {
        return path;
    }
    if (host.startsWith(exports.SH_SUBDOMAIN + '.')) {
        return path;
    }
    // ログインURLを account.* に統一するまでの間、顧客側の許可ドメインが
    // {org}.* のままでもログイン導線が死なないように、{org}.* で返す
    // TODO: 全顧客の許可ドメインが account.* に移行完了したら削除する(リリース1ヶ月後の2026/05/06を予定している)
    if (options === null || options === void 0 ? void 0 : options.allowOrgSubdomainLogin) {
        const orgSubdomain = host.slice(0, -suffix.length);
        return `https://${orgSubdomain}${suffix}${path}`;
    }
    return `https://${exports.SUBDOMAINS.accountPlatform}${suffix}${path}`;
}
function selectCookieDomain(host) {
    for (const suffix of Object.values(exports.DOMAIN_SUFFIXES)) {
        if (host.endsWith(suffix)) {
            return suffix.slice(1);
        }
    }
    return undefined;
}
